import { toast } from "react-toastify";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { getApiErrorMessage } from "@/modules/common/utils/apiError";
import { ADMIN_MANAGEMENT_COMPANIES_ENDPOINTS, AdminManagementCompaniesService } from "@/service/api/admin-management-companies";

const useCreateManagementCompany = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: AdminManagementCompaniesService.createManagementCompany,
    onError: (error) => {
      toast.error(getApiErrorMessage(error, "Erro ao cadastrar gestora. Tente novamente mais tarde."), {
        toastId: "create_management_company_error",
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [ADMIN_MANAGEMENT_COMPANIES_ENDPOINTS.GET_MANAGEMENT_COMPANIES] });
      queryClient.invalidateQueries({ queryKey: [ADMIN_MANAGEMENT_COMPANIES_ENDPOINTS.GET_TOTALIZERS] });
      queryClient.invalidateQueries({ queryKey: [ADMIN_MANAGEMENT_COMPANIES_ENDPOINTS.GET_OWNERS] });
    },
  });
};

export default useCreateManagementCompany;
